angular.module('impactx.panel').controller('LotPreviewPanelCtrl', [
    '$scope',
    'TranslationService',
    'panelService',
    'ImageEditor',
    LotPreviewPanelCtrl]);

function LotPreviewPanelCtrl($scope, TranslationService, panelService, ImageEditor) {
    var self = this;
    $scope.lotLabel = TranslationService.get('lot');
    self.getLotPanelColor = panelService.getLotPanelColor;

    self.deleteImage = function (event) {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        self.image.isDeleted = true;
        self.image.file = undefined;
        self.image.url = "img/missing-image.jpg";
    };

    self.openEditor = function (event, currentImage, newImage) {
        ImageEditor.open(event, currentImage, newImage, 'square').then(function (croppedImage) {
            self.image.file = croppedImage.image;
            self.image.fileName = croppedImage.name;
            self.image.isDeleted = true;
        })
    };

    $scope.$watch(function () {
        return impactX.isDefined(self, "image.file");
    }, function (newValue, oldValue) {
        if (newValue && !angular.equals(newValue, oldValue)) {
            self.image.isDeleted = true;
        }
    });
}